import React from 'react';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '@pascal/pascal-core/shared/core/store';
import {
  convertAmount,
  DefaultQueryParams,
  parseNumberByPrecision,
  parseQuery,
  useTranslation,
  useUserInfoStore,
} from '@pascal/pascal-core';

import { winningStore } from '../../store/winningStore';
import { TranslationKeys } from '../../enums/translationKeys';
import { RtlLanguages } from '../../enums/rtlLanguages.enum';

const FooterSection = observer(() => {
  const t = useTranslation();
  const { search } = useLocation();
  const { balance } = useUserInfoStore();
  const { lastWinAmount } = winningStore;
  const { currencySymbolOrCode } = userInfoStore;

  const { [DefaultQueryParams.Culture]: language } = parseQuery(search);

  const isRtl = RtlLanguages.find((el) => el === language);

  return (
    <div className='numeric-data-row'>
      <span className={`numeric-standard-el ${isRtl ? 'dirRtl' : ''}`}>
        {`${t(TranslationKeys.Balance)}: `}
        <var className={`${isRtl ? 'dirRtl' : ''}`}>
          {`${convertAmount(balance)} ${currencySymbolOrCode}`}
        </var>
      </span>
      <span className={`numeric-standard-el ${isRtl ? 'dirRtl' : ''}`}>
        {`${t(TranslationKeys.LastWin)}: `}
        <var className={`${isRtl ? 'dirRtl' : ''}`}>
          {!!lastWinAmount &&
            `${convertAmount(parseNumberByPrecision(lastWinAmount, 1, 2))} ${currencySymbolOrCode}`}
        </var>
      </span>
    </div>
  );
});

export default FooterSection;
